import React, {useState} from 'react';
import TogglerBody from '../TogglerBody';
import ChooseActionTamplate from '../actionTamplate/ChooseActionTamplate';
import CustomSliderRange from '../sliders/CustomSliderRange';
import CounterTemplate from '../status/statusBlock/CounterTemplate';
import TipsTamplate from '../TipsTamplate';
import {statusActionsAdvanced} from '../../../constants/common';
import './flagCustomisation.scss';

const FlagCustomisationItemCounter = ({item, data}) => {
  const [isTrigger, setIsTrigger] = useState(data ? data[item.trigger] : '');
  const [currentAction, setCurrentAction] = useState(
    data && data[item.keyName] ? data[item.keyName] : 'Kick',
  );

  return (
    <div style={{gap: '15px'}} className="flag_customisation_item_wrap">
      <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
        <h4>
          {item.title}
          {item.title === 'Webhook Management' ||
          item.title === 'Mass Spam' ||
          item.title === 'Name Similarity' ||
          item.title === 'AI-Based Text' ||
          item.title === 'Cross-server behaviour' ||
          item.title === 'Cross-Server Monitor' ||
          item.title === 'Cross-server deteciton' ||
          item.title === 'Account Age' ? (
            <label className="h4_label_pro" htmlFor="">
              PRO
            </label>
          ) : (
            <></>
          )}
        </h4>
        {item.tipsTitle && (
          <TipsTamplate
            title={item.tipsTitle}
            label={item.label}
            text={item.text}
            textSecond={item.textSecond}
          />
        )}
      </div>
      <p>Status</p>
      <div className="status_block_item_toggler">
        <TogglerBody isOn={isTrigger} setIsOn={setIsTrigger} keyName={item.trigger} advance />

        <p>{item?.targetTogler || 'Monitor kicks, bans and timeouts'}</p>
      </div>
      {item.counter.map((count, idx) => (
        <div className="safe_lable">
          <p style={{marginBottom: '10px'}}>{count.title}</p>
          {count.tipsTitle && (
            <div className="white_list_block_item_title_block flag_customisation_item_wrap_title">
              <TipsTamplate
                title={count.tipsTitle}
                label={count.label}
                text={count.text}
                textSecond={count.textSecond}
              />
            </div>
          )}
          <CounterTemplate
            data={{data: data}}
            keyName={count.keyName}
            keyTime={count.keyTime}
            valueTitle={count.target}
            valueTime={count.time}
            timeType={count.time}
            advance
          />
        </div>
      ))}
      {/* <p>Ban Frequency</p>
            <CounterTemplate
            valueTitle={'bans'}
            valueTime={'day'}
            />

                        <p>Timeout Frequency</p>
            <CounterTemplate
            valueTitle={'bans'}
            valueTime={'day'}
            /> */}
      {item?.targetSlader && (
        <>
          <p>Flag Sensitivity</p>
          <CustomSliderRange
            currentAction={currentAction}
            setCurrentAction={setCurrentAction}
            item={statusActionsAdvanced}
            color={'yellow'}
            keyName={item.sliderKeyName}
            data={{data: data}}
            advance
          />
        </>
      )}

      {item?.chooseActionTarget && (
        <>
          <p>Punishment</p>
          <ChooseActionTamplate
            keyName={item.keyName}
            currentAction={currentAction}
            setCurrentAction={setCurrentAction}
            actionArr={statusActionsAdvanced}
            advance
          />
        </>
      )}
    </div>
  );
};

export default FlagCustomisationItemCounter;
